import { convertWeight } from "helpers/commonHelpers";
import type { PackingListRow } from "@RequestFormV2/sections/PackingList/types";

export function getBaseWeightUnit(wUnit?: string | null): "kg" | "lbs" {
  const normalized = wUnit?.toLowerCase() ?? "";
  return normalized.includes("lbs") ? "lbs" : "kg";
}

function calculateItemCbm(item: PackingListRow) {
  const dimensionMultiplier = item.m_unit === "inch" ? 0.0254 : 0.01;
  const length = Number(item.length) * dimensionMultiplier;
  const width = Number(item.width) * dimensionMultiplier;
  const height = Number(item.height) * dimensionMultiplier;
  const units = Number(item.units);

  if (length && width && height && units) {
    return length * width * height * units;
  }
  return 0;
}

export function isTotalWeightUnit(wUnit?: string | null) {
  return Boolean(wUnit?.toLowerCase().includes("total"));
}

function calculateItemWeight(item: PackingListRow) {
  const weight = Number(item.weight_piece);
  const units = Number(item.units);
  if (!weight) return 0;

  if (isTotalWeightUnit(item.w_unit)) {
    return weight;
  }
  return weight * (units || 1);
}

export function calculatePackingListTotals(packingList: PackingListRow[] | undefined, targetWeightUnit?: "kg" | "lbs") {
  const rows = packingList ?? [];

  return rows.reduce(
    (acc, row) => {
      acc.totalUnits += Number(row.units) || 0;

      let weight = calculateItemWeight(row);
      if (targetWeightUnit) {
        const fromUnit = getBaseWeightUnit(row.w_unit);
        if (fromUnit !== targetWeightUnit) {
          weight = parseFloat(convertWeight(weight, { fromUnit, toUnit: targetWeightUnit }));
        }
      }
      acc.totalWeight += weight;

      acc.totalCBM += calculateItemCbm(row);
      return acc;
    },
    { totalUnits: 0, totalWeight: 0, totalCBM: 0 },
  );
}

export function formatPackingListWeight(value: number) {
  return value.toFixed(2);
}

export function formatPackingListCbm(value: number) {
  return value.toFixed(4);
}
